import React, {Component} from 'react';
import './advancedFuelReport.css';
import PieChart from './PieChart';
import LineChart from './LineChart';
import _ from 'lodash';
import StatsHistory from './StatHistory';
import { dateFormat, simpleTimeFormat, timeFormat, dateFormatWithSec } from '../../../../constants/constants';
import GeoCodeAPIs from '../../../../APIs/GeoCodeAPIs';
import moment from 'moment';
import {bisector} from 'd3';
import {duration} from './advancedFuelReport';
import ReactDOMServer from 'react-dom/server';

const point_time_key = 'endtime';

export const combineIdlingAlarms = (alarms, con) => {
    let ltranges = [];
    let procalam = alarms.map((alarm, i) => {
        if(alarm.alarmtype === 'Idling_Long_Start') {
            let end = _.find(alarms.slice(i), ['alarmtype', 'Idling_Long_End']);
            if(end) {
                let al = {
                    time: alarm.time,
                    duration: end.time - alarm.time,
                    alarmtype: 'Long Idling',
                    lat: alarm.lat,
                    lng: alarm.lng,
                }
                if(con) al.duration = duration(al.duration);
                ltranges.push([alarm.time, end.time]);
                return al;
            }
        } else if(alarm.alarmtype === 'Idling_Short_Start') {
            let end = _.find(alarms.slice(i), ['alarmtype', 'Idling_Short_End']);
            if(end) {
                let al = {
                    time: alarm.time,
                    duration: end.time - alarm.time,
                    alarmtype: 'Short Idling',
                    lat: alarm.lat,
                    lng: alarm.lng,
                }
                if(con) al.duration = duration(al.duration);
                return al;
            }
        }
        if(/Idling_(Short|Long)_End/.test(alarm.alarmtype)) {
            return null;
        }
        return alarm;
    })

    return _.filter(procalam, f => {
        if(f) {
            // remove all short idling that falls inside any long idling
            if(f.alarmtype === 'Short Idling') {
                return !ltranges.map(e => f.time >= e[0] && (f.time + f.duration) <= e[1]).includes(true);
            }
            return true;
        }
    });
}

function getIgnitionData(data) {
    let temp = null;
    let buckets = [];
    let rtgps = data[0];
    for(let i in rtgps) {
        let ig = rtgps[i].ignstatus;
        let time = rtgps[i].time;
        if(temp && ig === 0) {
            buckets.push(temp);
            temp = null;
        } else if(temp && ig === 1) {
            temp.endtime = time;
        } else if(ig === 1) {
            temp = {starttime: time, endtime: time};
        }
    }
    if(temp) buckets.push(temp);
    return buckets;
}

function findMovements(rtgpsData) {
    let md = [];
    let temp = null;
    for(let i in rtgpsData) {
        let d = rtgpsData[i];
        if(temp && d.speed < 5) {
            if(temp.duration > 0) md.push(temp);
            temp = null;
        } else if(temp && d.speed > 5) {
            temp.endodo = d.odometer;
            temp.endtime = d.time;
            temp.duration = temp.endtime - temp.starttime;
            temp.km = (temp.endodo - temp.startodo).toFixed(2);
        } else if(d.speed > 5) {
            temp = {startodo: d.odometer, starttime: d.time, endtime: d.time, endodo: d.odometer, duration: 0, km: '0'};
        }
    }
    if(temp) md.push(temp);
    return md;
}

function getIdlingData(data) {
    let rtgps = data[0];
    let rpm_data = data[1];
    let speed_data = data[6];
    let canMap = {}
    for(let i in rpm_data) {
        let rpm = rpm_data[i];
        let time = rpm.time;
        if(!canMap[time]) canMap[time] = {rpm: 0, speed: 0};
        canMap[time].rpm = rpm.value;
    }
    let totalSpeed = 0;
    let speeds = [];
    for(let i in speed_data) {
        let spd = speed_data[i];
        let time = spd.time;
        if(!canMap[time]) canMap[time] = {rpm: 0, speed: 0};
        canMap[time].speed = spd.value;
        totalSpeed += spd.value;
        if(!speeds.includes(spd.value)) speeds.push(spd.value);
    }
    // console.log('totalspeed', totalSpeed); // debug/remove
    // use gps speed if can speed not available
    if(totalSpeed === 0 || speeds.length === 1) {
        let bisect = bisector(d => d.time).left;
        for(let time of Object.keys(canMap)) {
            let di = bisect(rtgps, time, 0);
            let d0 = rtgps[di];
            let d1 = rtgps[di + 1];
            if(d0 && d1) {
                let d = time - d0.time < d1.time - time ? d0 : d1;
                canMap[time].speed = d.speed;
            }
        }
        // console.log('loop success', ff); // debug/remove
    }
    console.log('rpm speed combined', canMap); // debug/remove
    let getIdlingData = () => {
        let idles = [];
        let temp = null;
        let speedThreshold = 5;
        for(let i of Object.keys(canMap).sort()) {
            let time = parseInt(i, 10);
            let rpm = canMap[i].rpm;
            let speed = canMap[i].speed;
            if((speed > speedThreshold || rpm === 0) && temp) {
                idles.push(temp);
                temp = null;
            } else if(speed <= speedThreshold && rpm > 0 && temp) {
                temp.duration = time - temp.time;
            } else if(speed <= speedThreshold && rpm > 0) {
                temp = {time, duration: 0};
            }
        }
        if(temp) idles.push(temp);
        return idles.reduce((c, a) => c.concat(a), []);
    }
    let idles = getIdlingData();
    return idles.filter(f => f.duration > 10 * 60 * 1000);
}

class Table extends Component {
    state = {
        alerts: [],
        sortcol: '',
        desc: false,
    }
    setData = (alarms) => {
        this.alarms = alarms;
        this.setState({alerts: alarms}, this.fetchAddresses);
    }
    getData = () => {
        return this.state.alerts;
    }
    fetchAddresses = () => {
        let list = this.state.alerts.map(p => [p.lat, p.lng]);
        GeoCodeAPIs.getAddress(list).then(resp => {
            let alerts = this.state.alerts.map((p, i) => {
                p.address = _.get(resp, i + '.1');
                return p;
            });
            this.setState({alerts});
        }, err => console.log(err));
    }
    toggleCol = c => {
        let state = {sortcol: c};
        if(this.state.sortcol === c) state.desc = !this.state.desc;
        state.alerts = _.orderBy(this.alarms, [state.sortcol], [state.desc ? 'desc' : 'asc']);
        this.setState(state);
    }
    render() {
        let columns = [
            ['Alert', 'alarmtype', null, 'alarmtype'],
            ['Date', 'time', t => moment(t.time).format(dateFormat)],
            ['Duration', 'duration', t => duration(t.duration)],
            ['Location', 'address', null, 'address'],
        ];
        return (
            <div className="afbby">
                <table className={this.state.alerts.length > 0 ? 'hasd' : ''}>
                    <thead>
                        <tr>
                            {columns.map((f, i) => {
                                let icon = 'fa-sort';
                                if(this.state.sortcol === f[1]) icon = this.state.desc ? 'fa-sort-amount-desc' : 'fa-sort-amount-asc';
                                return <th key={i} onClick={e => this.toggleCol(f[1])}>{f[0]} <i className={'fa ' + icon}></i></th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.alerts.map((t, i) => {
                            return (
                                <tr key={i}>
                                    {columns.map((f, i) => {
                                        let props = {key: i}
                                        if(f[3]) props.title = f[3];
                                        let txt = t[f[1]];
                                        if(f[2]) txt = f[2](t);
                                        return <td {...props}>{txt}</td>
                                    })}
                                </tr>
                            )
                        })}
                        {this.state.alerts.length === 0 && <tr><td colSpan={4} style={{textAlign:'center'}}>No alerts</td></tr>}
                    </tbody>
                </table>
            </div>
        )
    }
}

class Tabs extends Component {
    state = {
        tab: 'refuel',
        refuel: 0,
        pilferage: 0,
        pilflist: [],
        refulist: [],
        norefuels: 0,
        nopilfs: 0,
        focused: '',
    }
    componentDidMount() {
        window.highLightTabItem = (item = '') => {
            this.setState({focused: item});
        }
    }
    setData = (data) => {
        let refuel_data = data[4];
        let pilferage_data = data[5];
        let refuel = refuel_data.reduce((c, r) => c + r.refuelLitres, 0);
        let pilferage = pilferage_data.reduce((c, r) => c + r.pilferageLitres, 0);
        this.setState({
            refuel: refuel.toFixed(2),
            pilferage: pilferage.toFixed(2),
            norefuels: refuel_data.length,
            nopilfs: pilferage_data.length,
            refulist: refuel_data,
            pilflist: pilferage_data,
        }, this.fetchAddresses);
    }
    fetchAddresses = () => {
        let list;
        list = this.state.pilflist.map(p => [p.lat, p.lng]);
        GeoCodeAPIs.getAddress(list).then(resp => {
            let pilflist = this.state.pilflist.map((p, i) => {
                p.address = _.get(resp, i + '.1');
                return p;
            });
            this.setState({pilflist});
        }, err => console.log(err));
        list = this.state.refulist.map(p => [p.lat, p.lng]);
        GeoCodeAPIs.getAddress(list).then(resp => {
            let refulist = this.state.refulist.map((p, i) => {
                p.address = _.get(resp, i + '.1');
                return p;
            });
            this.setState({refulist});
        }, err => console.log(err));
    }
    mouseenter = (d) => {
        if(window.highLightGraphPoint) window.highLightGraphPoint(d);
    }
    mouseleave = () => {
        if(window.highLightGraphPoint) window.highLightGraphPoint();
    }
    // pilferage row item
    renderPilf = () => {
        if(this.state.pilflist.length === 0) return <div style={{textAlign:'center'}}>No pilferage</div>;
        let {focused} = this.state;
        return this.state.pilflist.map((t, i) => {
            let highlight = '';
            if(focused.type === 'pilferage' && focused.time === t[point_time_key]) highlight = ' hglt';
            return <div className={"afbzi" + highlight} key={i} onMouseEnter={e => this.mouseenter(t)} onMouseLeave={this.mouseleave}>
                <div className="afbzj">
                    <div className="afbzc">
                        <span>{t.pilferageLitres}</span> ltr
                    </div>
                    <div className="afbzd">
                        <div></div> {moment(t.starttime).format(dateFormat)}
                    </div>
                </div>
                <div className="afbzj">
                    <div className="afbze">
                        <i className="fa fa-map-marker"></i> {t.address || 'N/A'}
                    </div>
                </div>
            </div>
        });
    }
    // refuel row item
    renderRefu = () => {
        if(this.state.refulist.length === 0) return <div style={{textAlign:'center'}}>No refuel</div>;
        let {focused} = this.state;
        return this.state.refulist.map((t, i) => {
            let highlight = '';
            if(focused.type === 'refuel' && focused.time === t[point_time_key]) highlight = ' hglt';
            return <div className={"afbzi" + highlight} key={i} onMouseEnter={e => this.mouseenter(t)} onMouseLeave={this.mouseleave}>
                <div className="afbzj">
                    <div className="afbzc">
                        <span>{t.refuelLitres}</span> ltr
                    </div>
                    <div className="afbzd">
                        <div></div> {moment(t.starttime).format(dateFormat)}
                    </div>
                </div>
                <div className="afbzj">
                    <div className="afbze">
                        <i className="fa fa-map-marker"></i> {t.address || 'N/A'}
                    </div>
                </div>
            </div>
        })
    }
    render() {
        let curTab = this.state.tab;
        let renderTabs = () => {
            let tabs = {
                'refuel': {
                    label: 'Refuel',
                    icon: (state) => state.norefuels ? <span className="grn">{state.norefuels}</span> : null,
                },
                'pilferage': {
                    label: 'Pilferage',
                    icon: (state) => state.nopilfs ? <span className="red">{state.nopilfs}</span> : null,
                },
            }
            return Object.keys(tabs).map(f => {
                let className = "afbza";
                if(curTab === f) className += ' actv';
                let props = {key: f, className, onClick: e => this.setState({tab: f})};
                return <div {...props}>
                    <div className="afbzw">
                        <div className="afbzu">{tabs[f].label}</div>
                        {tabs[f].icon && tabs[f].icon(this.state)}
                    </div>
                </div>
            });
        }
        let renderContent = () => {
            let content = <div style={{textAlign:'center'}}>No Data</div>;
            if(curTab === 'refuel') content = this.renderRefu();
            if(curTab === 'pilferage') content = this.renderPilf();
            return content;
        }
        return (
            <div className="afbhh">
                <div className="afbh">
                    <div className="afbu">Fuel Insights</div>
                </div>
                <div className="afbb">
                    <div className="afbz">
                        <div className="afbzz">
                            <div className="afbzx">
                                <div>Refuel</div>
                                <div className="afbzg">
                                    <div className="afbzr">{this.state.refuel} <span>ltr</span></div>
                                </div>
                            </div>
                            <div className="afbzx">
                                <div>Pilferage</div>
                                <div className="afbzg">
                                    <div className="afbzp">{this.state.pilferage} <span>ltr</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="afbzh">
                            {renderTabs()}
                        </div>
                        <div className="afbzb">
                            {renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class Pie extends Component {
    state = {
        idleLtr: 0,
        idlePerc: 0,
    }
    setData = (data, props) => {
        let {idlingData, runningData} = data;
        let badPts = 0;
        let okayPts = 0;
        // let totalPts = 0;
        let totalFuelUsed = 0;
        let idlingDuration = 0;
        for(let id of idlingData) {
            let dur = id.duration;
            if(dur > 600000) {
                badPts += 1;
                // totalPts += 1;
            } else if(dur <= 600000 && dur >= 300000) {
                okayPts += 1;
                // totalPts += 1;
            }
            totalFuelUsed += id.fuelused;
            idlingDuration += dur;
        }
        let totalDuration = runningData.reduce((c, t) => c + t.duration, 0) + idlingDuration;
        // console.log(idlingDuration, totalDuration);
        let idlePerc = totalDuration && idlingDuration ? idlingDuration / totalDuration * 100: 0;
        // let okayPerc = okayPts / totalPts * 100;
        // let badPerc = badPts / totalPts * 100;
        let piedata = [
            {
                key: 'okay', value: okayPts, color: '#f7ce19',
                // label: (okayPerc % 1 === 0 ? okayPerc : okayPerc.toFixed(1)) + '%',
            },
            {
                key: 'bad', value: badPts, color: '#ff4c4c',
                // label: (badPerc % 1 === 0 ? badPerc : badPerc.toFixed(1)) + '%',
            },
        ]
        this.refs.piechart.setData(piedata);
        let idleLtr = props.vehicle.data.fueltankcapacity * totalFuelUsed / 100;
        this.setState({idleLtr: idleLtr.toFixed(2), idlePerc: idlePerc.toFixed(2)});
    }
    redraw = () => {
        this.refs.piechart.redraw();
    }
    render() {
        return (
            <div className="afbbp">
                <div className="afbbpz">
                    <div className="afbbpp">
                        <div className="afbbpc">
                            <PieChart ref="piechart" />
                        </div>
                    </div>
                    <div className="afbbpr">
                        <div className="afbbpd">
                            <div className="afbbpe"><span>{this.state.idlePerc}</span> %</div>
                            <div className="afbbpf">Idling</div>
                        </div>
                        <div className="afbbps">
                            <div className="afbbpu"><span>{this.state.idleLtr}</span> ltr</div>
                            <div className="afbbpv">Fuel wasted during idling</div>
                        </div>
                    </div>
                </div>
                <div className="afbbpy">
                    <div className="afbbpt">
                        <div className="afbbpw">
                            <div></div> > 10 min
                        </div>
                        <div className="afbbpx">
                            <div></div> 5-10 min
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function makePoint(d, value) {
    let img = ReactDOMServer.renderToStaticMarkup(
        <div className={'ttxi ' + (d.refuelLitres ? 'rf' : 'pf')}>
            <div className="ttxl">
                <img src={require('./gasoline-pump.svg')} />
            </div>
            <div className="ttxr">
                <div className="ttxrh">{(d.refuelLitres || d.pilferageLitres) + ' ltrs'}</div>
                <div className="ttxrb">{moment(d.starttime).format(dateFormat)}</div>
            </div>
        </div>
    )
    return {
        color: d.refuelLitres ? '#1bb969' : '#ff603c',
        time: d[point_time_key],
        value,
        stroke: d.refuelLitres ? '#070' : '#700',
        lbl: img,
        type: d.refuelLitres ? 'refuel' : 'pilferage',
    }
}

class Line extends Component {
    componentDidMount() {
        window.highLightGraphPoint = (d) => {
            let item = null;
            if(d) {
                let f0 = bisector(d => d.time).left(this.fuellevels, d[point_time_key]);
                if(f0 > -1) {
                    item = makePoint(d, this.fuellevels[f0].value);
                }
            }
            this.refs.linechart.highLightItem(item);
        }
    }
    setData = (data, props) => {
        let colors = [];
        let points = [];
        let fuellevels = this.fuellevels = data[3];
        let refuel = data[4];
        let pilferage = data[5];
        let starttime = _.get(_.first(fuellevels), 'time', 0);
        let endtime = _.get(_.last(fuellevels), 'time', 0);
        let timerange = endtime - starttime;
        let combined = refuel.concat(pilferage);
        let getColorItem = (st, et, color) => {
            let width = (et - st) / timerange * 100;
            let from = (st - starttime) / timerange * 100;
            let to = from + width;
            return {from, to, color};
        }
        let bisect = bisector(d => d.time).left;
        if(combined.length > 0) {
            combined.sort((a, b) => a.starttime - b.starttime);
            if(combined[0].starttime > starttime) colors.push(getColorItem(starttime, combined[0].starttime, '#555'));
            for(let i in combined) {
                i = parseInt(i, 10);
                let item = combined[i];
                let item2 = combined[i + 1];
                colors.push(getColorItem(
                    item.starttime,
                    item.endtime,
                    item.refuelLitres ? '#0f0' : '#f00',
                ));
                if(item2) colors.push(getColorItem(item.endtime, item2.starttime, '#555'));
                let f0 = bisect(fuellevels, item[point_time_key]);
                if(f0 > -1) {
                    // make point
                    points.push(makePoint(item, fuellevels[f0].value));
                }
            }
            if(_.last(combined).endtime < endtime) colors.push(getColorItem(_.last(combined).endtime, endtime, '#555'));
        } else colors.push({from: 0, to: 100, color: '#555'});
        let fld = {
            name: 'fuellevels',
            // color: '#34495e',
            color: colors,
            points: fuellevels,
            dots: points,
            key: 'time',
        };
        let lcd = {title:'Fuel levels',items:[fld]};
        this.refs.linechart.setData(lcd);
    }
    render() {
        return (
            <div className="afblr">
                <LineChart ref="linechart" />
            </div>
        )
    }
}

const processAlarmData = (data, props) => {
    let getOverspeeding = (data, limit) => {
        let overspeeding = [];
        let temp = null;
        let overspeedDurThresold = 5000;
        for(let i in data) {
            let d = data[i];
            let s = d.speed;
            if(s < limit && temp) {
                let dur = temp.endtime - temp.starttime;
                if(dur >= overspeedDurThresold) overspeeding.push(Object.assign(_.pick(temp, ['lat', 'lng']), {time: temp.starttime, alarmtype: 'Overspeeding', duration: temp.endtime - temp.starttime}));
                temp = null;
            } else if(s > limit && temp) {
                temp.endtime = d.time;
            } else if(s > limit) {
                temp = {starttime: d.time, endtime: d.time, lat: d.latitude, lng: d.longitude};
            }
        }
        return overspeeding;
    }
    let alarms = data[2];
    // console.log(alarms)
    let rtgps = data[0];
    let overspeeding = getOverspeeding(rtgps, props.limit);

    let idling = combineIdlingAlarms(alarms).filter(f => /(Short|Long) Idling/.test(f.alarmtype));
    alarms = alarms.filter(f => !/Idling_(Short|Long)_(Start|End)/.test(f.alarmtype));

    alarms = alarms.concat(overspeeding).concat(idling);
    alarms.sort((a, b) => a.time - b.time);
    return alarms;
}

// using ignition data, cut out irrelevant idling
const refineIdlingData = (alarms, ignitionData) => {
    let splitIdls = (temp) => {
        let idls = [];
        for(let ig of ignitionData) {
            let starttime = temp.time;
            let endtime = starttime + temp.duration;
            if(ig.starttime < endtime && starttime < ig.endtime) {
                let st = Math.max(ig.starttime, starttime);
                let et = Math.min(ig.endtime, endtime);
                let idle = {
                    time: st,
                    duration: et - st,
                }
                idls.push(idle);
            }
        }
        return idls;
    }
    return alarms.reduce((c, a) => c.concat(splitIdls(a)), []);
}

const attachFuelUsage = (data, idling) => {
    let fuel_data = data[3];
    let refuel_data = data[4];
    const findFuelUsed = (idle) => {
        let starttime = idle.time;
        let endtime = starttime + idle.duration;
        let fueld = fuel_data.filter(f => f.time >= starttime && f.time <= endtime);
        if(fueld.length === 0) return 0;
        let chunks = [];
        for(let i in refuel_data) {
            let rf = refuel_data[i];
            let fz = fueld.filter(f => f.time < rf.starttime);
            fueld = fueld.filter(f => f.time > rf.endtime);
            if(fz.length) chunks.push(fz);
        }
        if(fueld.length) chunks.push(fueld);
        return chunks.reduce((c, a) => c + Math.max(0, a[0].value - a[a.length - 1].value), 0);
    }
    idling.forEach(f => {
        f.fuelused = findFuelUsed(f);
    })
}

const gears = [
    ['#2ecc71', ['1', <sup key={0}>st</sup>]],
    ['#3498db', ['2', <sup key={0}>nd</sup>]],
    ['#9b59b6', ['3', <sup key={0}>rd</sup>]],
    ['#f1c40f', ['4', <sup key={0}>th</sup>]],
    ['#e67e22', ['5', <sup key={0}>th</sup>]],
]

const rpmbands = [
    ['#2ecc71', 'Green'],
    ['#e74c3c', 'Red'],
]

class AdvancedFuelReportWidget extends Component {
    state = {
        stats: [],
        tDuration: 0,
        tDistance: 0,
        fuelUsed: 0,
        redPerc: 0,
        mileage: 0,
    }
    componentDidMount() {
        if(window.afrdata) this.setData(window.afrdata);
        let genData = (no) => {
            let colors = [
                '#2ecc71', '#3498db', '#9b59b6', '#f1c40f', '#e67e22', '#e74c3c'
            ];
            let total = 0;
            let points = [...Array(no).keys()].map(i => {
                let value = Math.round(Math.random() * 100);
                total += value;
                return {key: i, value, color: colors[i % colors.length]}
            });
            points.forEach(f => {
                let perc = f.value / total * 100;
                f.label = (perc % 1 === 0 ? perc : perc.toFixed(1)) + '%'
            });
            return points;
        }
        let pieconfig1 = genData(5)
        this.refs.gr1.setData(pieconfig1);
        let pieconfig2 = genData(3)
        this.refs.gr2.setData(pieconfig2);
    }
    getMileage = (data) => {
        let rtgps = data[0];
        if(rtgps.length === 0) return 0;
        let fuelconsumed = _.get(_.find(data[7], 'fuelused'), 'fuelused', 0);
        // console.log(fuelconsumed);
        let total_distance = _.get(_.find(data[7], 'tripdistance'), 'tripdistance', 0);
        let mileage = fuelconsumed ? total_distance / fuelconsumed : 0;
        return mileage.toFixed(2);
    }
    setData = (data) => {
        let toolbar = this.props.data.getSchema().toolbar;
        let props = {
            vehicle: toolbar[0].selectedItems[0],
            starttime: toolbar[1].ref.getData().unix() * 1000,
            endtime: toolbar[2].ref.getData().unix() * 1000,
            limit: toolbar[3].ref.value,
        }
        // console.log(data) // debug/remove
        let rtgpsData = data[0];
        let alarms = processAlarmData(data, props);
        // console.log(data[7])
        let tDistance = data[7].reduce((c, s) => c + s.tripdistance, 0);
        tDistance = tDistance.toFixed(2);
        let fuelUsed = _.get(_.find(data[7], 'fuelused'), 'fuelused', 0);
        fuelUsed = fuelUsed.toFixed(2);
        let ignitionData = getIgnitionData(data);
        // let idlingData = getIdlingData(data); // use rpm idling
        let idlingData = alarms.filter(f => /(Short|Long) Idling/.test(f.alarmtype)); // use voltage idling
        // idlingData = refineIdlingData(idlingData, ignitionData);
        attachFuelUsage(data, idlingData);
        this.idlingData = idlingData;
        let runningData = findMovements(rtgpsData);

        let tDuration = runningData.reduce((c, t) => c + t.duration, 0);
        tDuration = tDuration / 1000 / 60 / 60;
        tDuration = tDuration.toFixed(2);

        // console.log(runningData);
        let percs = this.refs.statshistory.setData(data, [idlingData, ignitionData, runningData], props);
        let mileage = this.getMileage(data);
        this.setState({mileage,fuelUsed,tDistance,tDuration,redPerc:percs.bad});
        this.refs.pie.setData({idlingData, runningData}, props);
        this.refs.line.setData(data);
        this.refs.alertstable.setData(alarms);
        this.refs.repiltabs.setData(data);
        let getRPMBanding = () => {
            let total = 0;
            let items = [
                {
                    key: 'red',
                    color: '#e74c3c',
                    ext: f => f.value >= 1400,
                },
                {
                    key: 'green',
                    color: '#2ecc71',
                    ext: f => f.value >= 1200 && f.value < 1400,
                }
            ]
            let percs = items.map(i => {
                let count = data[1].filter(i.ext).length;
                total += count;
                return Object.assign({
                    key: i.key,
                    color: i.color,
                    value: count,
                });
            });
            percs.forEach(i => {
                let perc = i.value / total * 100;
                if(perc) perc = (perc % 1 === 0 ? perc : perc.toFixed(1));
                i.label =  perc ? perc + '%' : '';
            });
            return percs;
        }
        let rpm_banding = getRPMBanding();
        this.refs.gr3.setData(rpm_banding);
        
        let bisect = bisector(d => d.time).left;
        let list = idlingData.map(i => {
            let di = bisect(rtgpsData, i.starttime, 0);
            if(rtgpsData[di]) {
                let gps = rtgpsData[di];
                i.lat = gps.latitude;
                i.lng = gps.longitude;
                return [gps.latitude, gps.longitude];
            }
            return '';
        });
        GeoCodeAPIs.getAddress(list).then(resp => {
            idlingData.forEach((i, idx) => {
                i.address = _.get(resp, idx + '.1');
            });
            let fmt = f => [moment(f.starttime).format(dateFormatWithSec), duration(f.endtime - f.starttime), f.address];
            console.log(
                'idles',
                idlingData.filter(f => f.duration > 600000).map(fmt),
                idlingData.map(fmt),
            ); // debug/remove
        }, err => console.log(err));
    }
    getData = () => {
        let {mileage,fuelUsed,tDistance,tDuration,redPerc} = this.state;
        return {
            mileage: mileage + 'kmpl',
            fuelused: fuelUsed + 'kmph',
            distance: tDistance + 'km',
            duration: tDuration + 'hrs',
            redzoning: redPerc + '%',
            alarms: this.refs.alertstable.getData(),
            refuel: this.refs.repiltabs.state.refuel + 'ltrs',
            pilferage: this.refs.repiltabs.state.pilferage + 'ltrs',
            refuels: this.refs.repiltabs.state.refulist,
            pilferages: this.refs.repiltabs.state.pilflist,
        }
    }
    setBusy = () => {

    }
    expandWindow = (e) => {
        let p = e.target.closest('.afbx');
        p.classList.toggle('full');
        let pp = e.target.closest('.afr');
        pp.classList.toggle('child-expanded');
    }
    render() {
        const renderTime = (t) => {
            let el = [];
            let hr = parseInt(t, 10);
            let mn = parseInt(60 * (t % 1), 10);
            if((!hr && !mn) || hr) el = el.concat([<span key="hrs">{hr}</span>, 'hrs ']);
            if(mn) el = el.concat([<span key="min">{mn}</span>, 'min']);
            return el;
        }
        return (
            <div className="afr">
                <div className="afb">
                <div className="afbx nx t1">
                    <div className="afbt">
                        <div className="afbr">
                            <StatsHistory ref="statshistory" />
                        </div>
                    </div>
                </div>
                <div className="afbx t2">
                    <div className="afbt">
                        <div className="afbs">
                            <div className="afbsb">
                                <div className="afbsa blu">
                                    <div className="afbse"><img src={require('./distance.png')} /></div>
                                    <div className="afbsf">
                                        <div className="afbsd"><span>{this.state.tDistance}</span>kms</div>
                                        <div className="afbsc">Distance</div>
                                    </div>
                                </div>
                                <div className="afbsa grn">
                                    <div className="afbse"><img src={require('./fuel.png')} /></div>
                                    <div className="afbsf">
                                        <div className="afbsd"><span>{this.state.fuelUsed}</span>ltr</div>
                                        <div className="afbsc">Fuel Consumed</div>
                                    </div>
                                </div>
                                <div className="afbsa pur">
                                    <div className="afbse"><img src={require('./mileage.png')} /></div>
                                    <div className="afbsf">
                                        <div className="afbsd"><span>{this.state.mileage}</span>kmpl</div>
                                        <div className="afbsc">Mileage</div>
                                    </div>
                                </div>
                                <div className="afbsa pnk">
                                    <div className="afbse"><img src={require('./running_hours.png')} /></div>
                                    <div className="afbsf">
                                        <div className="afbsd">{renderTime(this.state.tDuration)}</div>
                                        <div className="afbsc">Running hours</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="afbx gx t3">
                    <div className="afbt">
                        <Tabs ref="repiltabs" />
                    </div>
                </div>
                <div className="afbx gx t4">
                    <div className="afbt">
                        <div className="afbh">
                            <div className="afbu">Engine Idling</div>
                        </div>
                        <div className="afbb">
                            <Pie ref="pie" />
                        </div>
                    </div>
                </div>
                <div className="afbx gx t5">
                    <div className="afbt">
                        <div className="afbh">
                            <div className="afbu">Critical Alerts <button onClick={this.expandWindow}><i className="fa fa-expand"></i></button></div>
                        </div>
                        <div className="afbb">
                            <Table ref="alertstable" />
                        </div>
                    </div>
                </div>
                <div className="afbx nx t6">
                    <div className="afbt">
                        <div className="afbl">
                            <Line ref="line" />
                        </div>
                    </div>
                </div>
                <div className="afbx gx t7">
                    <div className="afbt">
                        <div className="afbh">
                            <div className="afbu">Gear ratio</div>
                        </div>
                        <div className="afbb">
                            <div className="afbg">
                                <div className="af-legends">
                                    <div className="af-ls">
                                        {gears.map((g, i) => <div key={i} className="af-lsi"><span style={{background:g[0]}}></span>{g[1]}</div>)}
                                    </div>
                                </div>
                                <PieChart ref="gr1" />
                            </div>
                            <div className="af-tx"><div><i className="fa fa-wrench"></i></div>Work in progress</div>
                        </div>
                    </div>
                </div>
                <div className="afbx gx t8">
                    <div className="afbt">
                        <div className="afbh">
                            <div className="afbu">Gear usage from standstill</div>
                        </div>
                        <div className="afbb">
                            <div className="afbg">
                                <div className="af-legends">
                                    <div className="af-ls">
                                        {gears.slice(0, 3).map((g, i) => <div key={i} className="af-lsi"><span style={{background:g[0]}}></span>{g[1]}</div>)}
                                    </div>
                                </div>
                                <PieChart ref="gr2" />
                            </div>
                            <div className="af-tx"><div><i className="fa fa-wrench"></i></div>Work in progress</div>
                        </div>
                    </div>
                </div>
                <div className="afbx gx t9">
                    <div className="afbt">
                        <div className="afbh">
                            <div className="afbu">RPM Banding</div>
                        </div>
                        <div className="afbb">
                            <div className="afbg">
                                <div className="af-legends">
                                    <div className="af-ls">
                                        {rpmbands.slice(0, 3).map((g, i) => <div key={i} className="af-lsi"><span style={{background:g[0]}}></span>{g[1]}</div>)}
                                    </div>
                                </div>
                                <PieChart ref="gr3" />
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default AdvancedFuelReportWidget;